import { useEffect, useState } from "react";
import CourseFavoriteCard from "../components/CourseFavoriteCard";
import FilterTopDash from "../components/FilterTopDash";
import "../styles/courses.css";
import { handleEnrollmentsFilterByUser } from "../../../store/actions/CreateCourse/CourseApi";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import CourseFavoriteCardLoading from "../components/CourseFavoriteCardLoading";
import ErrorNotFound from "../../UI/404/ErrorNotFound";
export default function FavoriteCourses({dashboardCard1Object}) {
    const [itemArr, setItemArr] = useState([]);
                 const [itemArrAll, setItemArrAll] = useState([]);
                 const [itemReorderArr, setItemReorderArr] = useState([]);
                 
                  const [itemArrLoading, setItemArrLoading] = useState([{},{},{},{}]);
          
 const [sort, setSort] = useState("ASC");
          const [pageNo, setPageNo] = useState(1);
          const [limit, setLimit] = useState(10);
        const [dropDownVal, setDropDownVal] = useState("Active");
           const [startDate, setStartDate] = useState(null);
     
       const [endDate, setEndDate] = useState(null);
 const [advancedFilters , setAdvancedFilters] =useState(true)
    const [toggleStatePaid , setToggleStatePaid] =useState(null)
    const [toggleStateLifetime , setToggleStateLifetime] =useState(null)
  
  const dispatch = useDispatch();
           const user = useSelector((state)=>state?.user?.user);
                
           const [snackbarVisible, setSnackbarVisible] = useState(false);
                            const [snackbarColor, setSnackbarColor] = useState("#958FDA");
                            const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
                      
                             
                         const showSnackbar = () => {
                           setSnackbarVisible(true);
                         };
                        
                         const hideSnackbar = () => {
                           setSnackbarVisible(false);
                         };
                   
                   
                              
                              
                           
                          const [animate, setAnimate] = useState(false);
            
             const [loader , setLoader] =useState({status:true});
    
        
               const currentToken = useSelector((state)=>state?.user?.user?.currentToken);
               const userEmail = useSelector((state)=>state?.user?.user?.userData?.userEmail
              );
              
                  const userData =useSelector((state)=>state?.user?.user);
                 const AppToken = useSelector((state)=>state?.user?.user?.appToken);
                 const appId = useSelector((state)=>state?.user?.user?.appId);
               
                         
      
    const fireGetEnrolledCoursesFilterClientApp=()=>{
           setItemArr([])
            
        
          setItemArrLoading([{},{},{},{}])
          setLoader({status:true});
                const apiData = dispatch(handleEnrollmentsFilterByUser({userEmail:userEmail?userEmail:"",
       currentToken:currentToken?currentToken:"",productType:"course",status:dropDownVal,
       paid:toggleStatePaid,lifetime:toggleStateLifetime,sort:sort,startDate:startDate,endDate:endDate,
       pageNo:pageNo,limit:limit,
        actionType:"freeEnroll",productId:""}));
                /* get response as Promise   */
                apiData.then(response => {
                console.log(response)
          
                  if(response?.enrollments){
                  setItemArr(response?.enrollments);
                  
          setItemArrLoading([])
                  setResponseMessage(response?.message);
                  setSnackbarColor("rgba(144, 202, 249,1)");
                
              setLoader({status:false});
              
              // setSnackbarVisible(true);
              setTimeout(()=>{
                
                setSnackbarVisible(false);
              },1000)
              
                    
                  
                 if(response?.logout){
                 
                  setResponseMessage("You are Logged Out!!!");
                    
                  setSnackbarColor("#958FDA");
                
                  
                   
              setLoader({status:false});
              
              setSnackbarVisible(true);
              setTimeout(()=>{
                
                setSnackbarVisible(false);
               
                 
              },3000)
                  setTimeout(()=>{
                    dispatch({type:"LOGOUT"});
              
                  },3000)
                  
                }
              
                  }else{
                    setResponseMessage("Something Went Wrong...");
                    
                    setSnackbarColor("#958FDA");
                  
                     
                setLoader({status:false});
                
                setSnackbarVisible(true);
                setTimeout(()=>{
                  
                  setSnackbarVisible(false);
                 
                   
                },3000)    }
              
                }).catch(error => {
               
                  //popup of error Info
                  setResponseMessage("Something Went Wrong...");
                    
                  setSnackbarColor("#958FDA");
               
                  
                   
              setLoader({status:false});
              
              setSnackbarVisible(true);
              setTimeout(()=>{
                
                setSnackbarVisible(false);
               
                 
              },3000)
                 
                });
           }
  

useEffect(()=>{fireGetEnrolledCoursesFilterClientApp()},[sort,dropDownVal,startDate,endDate,toggleStatePaid ,toggleStateLifetime ,])
  const flattenedData = itemArr!=[]?Object.values(itemArr):'';

         const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';
 

  return (
    <div className="pageDashB">
     
 <FilterTopDash sort={sort}  dropDownVal={dropDownVal} setDropDownVal={(v)=>{setDropDownVal(v)}}
 setExpStartDate={(v)=>{setStartDate(v)}}
setExpEndDate={(v)=>{setEndDate(v)}}
 setEnrollStartDate={(v)=>{setStartDate(v)}}
setEnrollEndDate={(v)=>{setEndDate(v)}}
  setSort={(v)=>{setSort(v)}}  advancedFilters={advancedFilters} 
  setPageNo={(v)=>{setPageNo(v)}}
  setAdvancedFilters={(v)=>{setAdvancedFilters(v)}}
  toggleStatePaid={toggleStatePaid}
   setToggleStatePaid={(v)=>{setToggleStatePaid(v)}}
   toggleStateLifetime={toggleStateLifetime} 
    setToggleStateLifetime={(v)=>{setToggleStateLifetime(v)}}
    dashboardCard1Object={dashboardCard1Object}/>
      <div className="courses-list">
     {flattenedDataLoading?.length==0?flattenedData?.length?
flattenedData?.map((item,index)=>(<div key={index}>   <CourseFavoriteCard

        dashboardCard1Object={dashboardCard1Object} item={item}
        
        /></div>)):"":""}
        {flattenedData?.length==0?flattenedDataLoading?.length?flattenedDataLoading?.map((item,index)=>(<div key={index}> 
            <CourseFavoriteCardLoading

        dashboardCard1Object={dashboardCard1Object} 
        
        /></div>)):"":""}
        {flattenedDataLoading?.length==0?flattenedData?.length?"": <div style={{display:"flex",justifyContent:"center"}}>
    <ErrorNotFound /> 

    </div>:""}
      </div>
    </div>
  );
}
